import * as React from "react";
import { GenericDialog } from "../generic-dialog/GenericDialog.component";
import { AvatarEditor } from "../../components/avatar-editor/AvatarEditor.component";
import { useTranslation } from "react-i18next";
export function AvatarSettingsDialog(_a) {
    var _b;
    var { onClose, username = (_b = localStorage.getItem("username")) !== null && _b !== void 0 ? _b : "Guest" } = _a;
    const { t } = useTranslation();
    return (React.createElement(GenericDialog, { title: t("settings:avatar-edit-dialog-title", "Edit Avatar"), confirmText: t("settings:avatar-edit-dialog-button-confirm", "Close"), hideCancel: true, width: "medium", noContentPadding: true, minWidth: 750, onConfirm: onClose, onCancel: onClose },
        React.createElement(AvatarEditor, { username: username })));
}
